<template>
    <div class="multi-selector-container">
      <div class="multi-slider">
        <slot></slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'MonthSelectorContainer'
  };
  </script>
  
  <style scoped lang="scss">
  .multi-selector-container {
    width: 100%;
    overflow-x: auto;
    position: relative;
  }
  
  .multi-slider {
    display: flex;
    gap: 8px;
    padding: 8px 0;
  }
  </style>